import { ServiceData } from '@/types';

import articles from './COOKING_ARTICLES_DK.json';
import recipes from './COOKING_RECIPES_DK.json';
import videos from './COOKING_VIDEOS_DK.json';

export const COOKING_DATA_DK: ServiceData = {
  articles,
  recipes,
  videos,
};
